"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactIntl = require("react-intl");

var _Money = _interopRequireDefault(require("./Money"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BoldText = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: bold;\n"])));

var RedText = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  color: ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.red || 'red';
});

var Highlight = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  color: ", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
});

var GreenText = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  color: ", "\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.green;
});

var Link = function Link(_ref4) {
  var children = _ref4.children,
      onClick = _ref4.onClick;
  return /*#__PURE__*/_react["default"].createElement("a", {
    href: "#",
    onClick: onClick
  }, children);
};

Link.propTypes = {
  children: _propTypes["default"].object,
  onClick: _propTypes["default"].func
};

var FormattedTranslationStyled = function FormattedTranslationStyled(_ref5) {
  var defaultMessage = _ref5.defaultMessage,
      id = _ref5.id,
      onClick = _ref5.onClick,
      values = _ref5.values;
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: id,
    defaultMessage: defaultMessage,
    values: _objectSpread({
      a: function a(chunks) {
        return /*#__PURE__*/_react["default"].createElement(Link, {
          onClick: onClick
        }, chunks);
      },
      red: function red(chunks) {
        return /*#__PURE__*/_react["default"].createElement(RedText, null, chunks);
      },
      highlight: function highlight(chunks) {
        return /*#__PURE__*/_react["default"].createElement(Highlight, null, chunks);
      },
      green: function green(chunks) {
        return /*#__PURE__*/_react["default"].createElement(GreenText, null, chunks);
      },
      bold: function bold(chunks) {
        return /*#__PURE__*/_react["default"].createElement(BoldText, null, chunks);
      },
      money: function money(chunks) {
        return /*#__PURE__*/_react["default"].createElement(_Money["default"], {
          amount: chunks
        });
      },
      newLine: /*#__PURE__*/_react["default"].createElement("br", null)
    }, values)
  });
};

FormattedTranslationStyled.propTypes = {
  defaultMessage: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func,
  values: _propTypes["default"].object
};

var _default = exports["default"] = FormattedTranslationStyled;